import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function DialogCampanhaInfo({
  PaperComponent,
  open,
  onClose,
  campanhaSelecionada,
  loading,
  materiaisCampanha,
  alternativasPorMaterial,
  alternativasGerais,
  ofertasCliente,
  alternativasOfertasCliente,
  beneficios,
  filtrosCampanha,
  clientesAcordosCampanha,
}) {
  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", lg: "1100px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Informação da campanha
        {campanhaSelecionada?.nome ? ` — ${campanhaSelecionada.nome}` : ""}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="300px">
            <CircularProgress />
          </MDBox>
        ) : campanhaSelecionada ? (
          <MDBox
            display="grid"
            gap={2}
            mt={1}
            sx={{
              maxWidth: "100%",
            }}
          >
            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Resumo
              </MDTypography>

              <MDBox
                display="grid"
                gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr 1fr" }}
                gap={1}
              >
                <MDTypography variant="caption">
                  <b>Código:</b> {campanhaSelecionada.codigo_campanha}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Fabricante:</b> {campanhaSelecionada.fabricante}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Contacto:</b> {campanhaSelecionada.contacto_nome || "-"}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Email:</b> {campanhaSelecionada.contacto_email || "-"}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Data inicial:</b> {campanhaSelecionada.datainicial?.substring(0, 10)}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Data final:</b> {campanhaSelecionada.datafinal?.substring(0, 10)}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Estado:</b> {campanhaSelecionada.estado}
                </MDTypography>

                <MDTypography variant="caption">
                  <b>Período:</b> {campanhaSelecionada.estado_periodo}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Observações
              </MDTypography>

              <MDTypography variant="caption">{campanhaSelecionada.obs || "-"}</MDTypography>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Materiais principais
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 760,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Ref.</th>
                    <th style={thLeft}>Material</th>
                    <th style={thRight}>Qtd</th>
                    <th style={thLeft}>Unid.</th>
                    <th style={thRight}>Desc. máx.</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(materiaisCampanha || []).map((m) => (
                    <tr key={m.id}>
                      <td style={tdBase}>{m.refmaterial}</td>
                      <td style={tdBase}>{m.material}</td>
                      <td style={tdRight}>{m.qtd}</td>
                      <td style={tdBase}>{m.unidade}</td>
                      <td style={tdRight}>{Number(m.descprommaxfabricante || 0).toFixed(2)}</td>
                      <td style={tdBase}>{m.obs || ""}</td>
                    </tr>
                  ))}

                  {(materiaisCampanha || []).length === 0 && (
                    <tr>
                      <td colSpan={6} style={tdEmpty}>
                        Sem materiais principais definidos.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Alternativas dos materiais principais
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Material principal</th>
                    <th style={thLeft}>Ref. alternativa</th>
                    <th style={thLeft}>Material alternativo</th>
                    <th style={thRight}>Qtd</th>
                    <th style={thLeft}>Unid.</th>
                    <th style={thRight}>Fator</th>
                    <th style={thRight}>Desc. máx.</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(materiaisCampanha || []).flatMap((m) =>
                    (alternativasPorMaterial?.[m.id] || []).map((a) => (
                      <tr key={a.id}>
                        <td style={tdBase}>{m.material || m.refmaterial}</td>
                        <td style={tdBase}>{a.refmaterialalternativo}</td>
                        <td style={tdBase}>{a.materialalternativo}</td>
                        <td style={tdRight}>{a.qtd}</td>
                        <td style={tdBase}>{a.unidade}</td>
                        <td style={tdRight}>
                          {Number(a.fatorequivalencia || 1)
                            .toFixed(3)
                            .replace(/\.?0+$/, "")}
                        </td>
                        <td style={tdRight}>{Number(a.descprommaxfabricante || 0).toFixed(2)}</td>
                        <td style={tdBase}>{a.obs || ""}</td>
                      </tr>
                    ))
                  )}

                  {(materiaisCampanha || []).flatMap((m) => alternativasPorMaterial?.[m.id] || [])
                    .length === 0 && (
                    <tr>
                      <td colSpan={8} style={tdEmpty}>
                        Sem alternativas específicas definidas.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Alternativas gerais
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Ref.</th>
                    <th style={thLeft}>Material</th>
                    <th style={thRight}>Fator</th>
                    <th style={thRight}>Desc. máx.</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(alternativasGerais || []).map((a) => (
                    <tr key={a.id}>
                      <td style={tdBase}>{a.refmaterialalternativo}</td>
                      <td style={tdBase}>{a.materialalternativo}</td>
                      <td style={tdRight}>
                        {Number(a.fatorequivalencia || 1)
                          .toFixed(3)
                          .replace(/\.?0+$/, "")}
                      </td>
                      <td style={tdRight}>{Number(a.descprommaxfabricante || 0).toFixed(2)}</td>
                      <td style={tdBase}>{a.obs || ""}</td>
                    </tr>
                  ))}

                  {(alternativasGerais || []).length === 0 && (
                    <tr>
                      <td colSpan={5} style={tdEmpty}>
                        Sem alternativas gerais definidas.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Ofertas ao cliente
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Ref. oferta</th>
                    <th style={thLeft}>Material oferta</th>
                    <th style={thRight}>Qtd</th>
                    <th style={thLeft}>Unid.</th>
                    <th style={thLeft}>Alternativas</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(ofertasCliente || []).map((o) => {
                    const alternativas = alternativasOfertasCliente?.[o.id] || [];

                    return (
                      <tr key={o.id}>
                        <td style={tdBase}>{o.refmaterialoferta}</td>
                        <td style={tdBase}>{o.materialoferta}</td>
                        <td style={tdRight}>{o.qtd}</td>
                        <td style={tdBase}>{o.unidade}</td>
                        <td style={tdBase}>
                          {alternativas.length > 0
                            ? alternativas
                                .map((a) => a.materialalternativo || a.refmaterialalternativo)
                                .join(", ")
                            : "-"}
                        </td>
                        <td style={tdBase}>{o.obs || ""}</td>
                      </tr>
                    );
                  })}

                  {(ofertasCliente || []).length === 0 && (
                    <tr>
                      <td colSpan={6} style={tdEmpty}>
                        Sem ofertas ao cliente definidas.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Benefícios
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Tipo</th>
                    <th style={thLeft}>Aplicação</th>
                    <th style={thRight}>Valor</th>
                    <th style={thLeft}>Ref. oferta</th>
                    <th style={thLeft}>Material oferta</th>
                    <th style={thRight}>Qtd oferta</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(beneficios || []).map((b) => (
                    <tr key={b.id}>
                      <td style={tdBase}>{b.tipobeneficio}</td>
                      <td style={tdBase}>{b.basecalculo || "-"}</td>

                      <td style={tdRight}>
                        {b.tipobeneficio === "VALOR_FIXO"
                          ? Number(b.valor_eur || 0).toFixed(2)
                          : b.tipobeneficio === "VALOR_POR_UNIDADE"
                          ? Number(b.valor_por_unidade || 0).toFixed(2)
                          : b.tipobeneficio === "PERCENTAGEM"
                          ? `${Number(b.percentagem || 0).toFixed(2)}%`
                          : "-"}
                      </td>
                      <td style={tdBase}>{b.refmaterialoferta || "-"}</td>
                      <td style={tdBase}>{b.materialoferta || "-"}</td>
                      <td style={tdRight}>{b.qtdoferta ? Number(b.qtdoferta).toFixed(2) : "-"}</td>
                      <td style={tdBase}>{b.obs || ""}</td>
                    </tr>
                  ))}

                  {(beneficios || []).length === 0 && (
                    <tr>
                      <td colSpan={7} style={tdEmpty}>
                        Sem benefícios definidos.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Filtros comerciais / clientes
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Campo</th>
                    <th style={thLeft}>Tipo</th>
                    <th style={thLeft}>Valor</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(filtrosCampanha || []).map((f) => (
                    <tr key={f.id}>
                      <td style={tdBase}>{f.campo}</td>
                      <td style={tdBase}>{f.tipo}</td>
                      <td style={tdBase}>{f.valor}</td>
                      <td style={tdBase}>{f.obs || ""}</td>
                    </tr>
                  ))}

                  {(filtrosCampanha || []).length === 0 && (
                    <tr>
                      <td colSpan={4} style={tdEmpty}>
                        Sem filtros definidos.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>

            <MDBox
              p={{ xs: 1.25, md: 2 }}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <MDTypography variant="h6" mb={1}>
                Clientes com acordos / exclusões
              </MDTypography>

              <table
                style={{
                  width: "100%",
                  minWidth: 920,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={thLeft}>Ref.</th>
                    <th style={thLeft}>Cliente</th>
                    <th style={thLeft}>Tipo</th>
                    <th style={thLeft}>Obs</th>
                  </tr>
                </thead>

                <tbody>
                  {(clientesAcordosCampanha || []).map((c) => (
                    <tr key={c.id}>
                      <td style={tdBase}>{c.refcliente}</td>
                      <td style={tdBase}>{c.cliente}</td>
                      <td style={tdBase}>{c.tipo || "-"}</td>
                      <td style={tdBase}>{c.obs || ""}</td>
                    </tr>
                  ))}

                  {(clientesAcordosCampanha || []).length === 0 && (
                    <tr>
                      <td colSpan={4} style={tdEmpty}>
                        Sem clientes específicos configurados.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        ) : null}
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

const thBase = {
  fontSize: 12,
  padding: 6,
  borderBottom: "1px solid #e0e0e0",
  color: "#344767",
};

const thLeft = {
  ...thBase,
  textAlign: "left",
};

const thRight = {
  ...thBase,
  textAlign: "right",
};

const tdBase = {
  fontSize: 12,
  padding: 6,
  borderTop: "1px solid #eee",
};

const tdRight = {
  ...tdBase,
  textAlign: "right",
};

const tdEmpty = {
  fontSize: 12,
  padding: 8,
  color: "#7b809a",
  borderTop: "1px solid #eee",
};
